export const questionsQueryKeys = {
  questions: (params) => ['questions', params],
  types: () => ['questionTypes'],
  states: () => ['questionStates'],
  attachmentList: (questionId) => ['questionAttachmentList', questionId],
  questionImgPreview: (imgId) => ['questionImgPreview', imgId],
  attachment: (attachId) => ['questionAtttachment', attachId],
  questionMessages: (questionId) => ['questionMessages', questionId],
  questionMsgAttachList: (msgId) => ['questionMsgAttachList', msgId],
  messageImgPreview: (imgId) => ['messageImgPreview', imgId],
  messageAttachment: (attachId) => ['questionMsgAttachment', attachId],
  companyDefaultSignature: (questionId) => [
    'companyDefaultSignature',
    questionId,
  ],
  questionById: (questionId) => ['questionById', questionId],
};
